import { DropOffLinkType } from "src/Core/Common/Enums";
import { IUserDefaultSettingsStates } from "src/Core/Domain/Settings/MySettings";
import { AuthenticationProvider } from "src/Core/ViewModels/Company/Settings/CompanySettingsViewModel";

export interface IUserModel {
    userId: number;
    firstName: string;
    middleName: string;
    lastName: string;
    phoneNumber: string;
    extension: string;
    ptin: string;
    email: string;
    confirmEmail: string;
    faxNumber: string;
    title: string;
    customUserGroup: IUserGroups[];
    createdOn?: any;
    password?: string;
    authenticationProviders: AuthenticationProvider[];
    metadata: string;
    isDeceased: boolean;
    mobileNumber: string;
    countryCode: string;
    isMobileVerify: boolean;
    userSettings: IUserDefaultSettingsStates;
    lastLogin: Date;
}

export interface IUserGroups {
    id: number;
    name: string;
    userId?: number;
    userGroups?: number;
}

export enum IUserGroup {
    None,
    SystemAdmin = 1,
    Staff,
    Partner,
    Signatures,
    Exchange,
}

export interface IUserMetaData {
    readonlyFields: IUserReadonlyFields;
}

export interface IUserReadonlyFields {
    providerData: IExternalAuthenticationProviderFields[];
}

export interface IExternalAuthenticationProviderFields {
    provider: AuthenticationProvider;
    fields: string[];
}

export interface IDelegateeUser {
    userId: number;
    firstName: string;
    lastName: string;
    emailAddress: string;
    email: string; // added for now as it is required for automation task. its coming as email from GetAllowedMailboxUsersAsync api
    metadata?: string;
}

export interface IUserMfaSettings {
    isMfaEnabled: boolean;
}

export interface IUserSendOptionSettings {
    defaultAuthenticationMethod: number;
}

export interface IUserRetentionSettings {
    defaultRetentionPeriods: {
        // loginTransfer: number;
        questionAndAnswer: number;
        accessCode: number;
        dropOffTransfer: number;
        folders: number;
    };
}

export interface IUserLinkAuthenticationSettings {
    defaultSecurityQuestionId: number;
}

export interface IMessageSecurityQuestionSettings {
    defaultSecurityQuestionId: number;
}

export interface ISavedMessageTemplateSettings {
    defaultSavedMessageTemplateId: number;
}

export interface ISavedMessageDRTemplateSettings {
    defaultSavedMessageDRTemplateId: number;
}
export interface IUserSettingsModel {
    userId: number;
    mfaSettings: IUserMfaSettings;
    authenticationMethodSettings: IUserSendOptionSettings;
    retentionSettings: IUserRetentionSettings;
    messageSecurityQuestionSettings: IMessageSecurityQuestionSettings;
    mailboxDelegationSettings: number[] | null;
    dropOffSettings: {
        dropOffLinkType: number | DropOffLinkType;
    };
    supportContactSettings: {
        contactId: number | 0;
        locationId: number | 0;
    };
    notificationsSettings: INotificationsSettings;
    documentRequestNotificationsSettings: IDocumentRequestNotificationSettings;
    savedMessageTemplateSettings: ISavedMessageTemplateSettings;
    savedMessageDRTemplateSettings: ISavedMessageDRTemplateSettings;
    folderNotificationSettings: IFolderNotificationsSettings;
    taxYearSettings: {
        defaultTaxYear: number;
    };
}

export enum PageDisabledTypes {
    SubscriptionTier = 1,
    ProductDisabled,
    NoPermission,
    PageAccessDenied,
}

export interface IReportProblemModel {
    cpaEmail: string;
    cpaPhoneNumber?: string;
    description: string;
    attachment?: string;
    isAttachmentPresent: boolean;
}

export interface ISupportContactSettings {
    contactId: number;
    locationId: number;
}

export interface INotificationsSettings {
    isExpiryNotificationEnable: boolean;
    isDownloadNotificationEnable: boolean;
}
export interface IDocumentRequestNotificationSettings {
    isDocumentRequestCompletionNotificationEnabled: boolean;
    isDocumentRequestReopenNotificationEnabled: boolean;
}
export interface IFolderNotificationsSettings {
    isFolderNotificationEnabled: boolean;
}
